<button class="ws-flex-none ace-btn has-icon btn-secondary my-0 ms-1" [title]="helpContent" (click)="show()">
    <i class="fa fa-hourglass-half"></i>
</button>
